<template>
<div>           
    <div class="mt-5 py-5 bt-0 border-top">
        <HeaderShop />
        <div class="row justify-content-center">

                <div class="container-fluid">

                    <div class="row mb-5">
                        <div class="col">
                            <a :href="linklinenotify" class="btn btn-success"><i class="ni ni-bell-55"></i> ตั้งค่าการแจ้งเตือนผ่านไลน์</a>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-12 mb-2"><h5 class="text-center">ข้อมูลที่ใช้สำหรับออกใบกำกับภาษี</h5></div>
                        <div class="col-lg-12 col-md-6">
                                        <div class="row">
                                            
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label><i class="fa fa-home"></i> ชื่อร้านค้า</label>
                                                    <input type="text" class="form-control" v-model="rs_getbyShops.shops_name" placeholder="ชื่อร้านค้า" name="shops_name">
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label><i class="fa fa-id-card-o"></i> หมายเลขประจำตัวประชาชน/เลขประจำตัวผู้เสียภาษี</label>
                                                    <input type="number" 
                                                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "13"
                                                    name="shops_cardid" v-model="rs_getbyShops.shops_cardid" id="shops_cardid" class="form-control" placeholder="หมายเลขประจำตัวประชาชน/เลขประจำตัวผู้เสียภาษี">
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group" >
                                                    <label><i class="fa fa-user-circle-o"></i> ชื่อ</label>
                                                    <input type="text" class="form-control" v-model="rs_getbyShops.shops_firstname" id="shops_firstname" name="shops_firstname" placeholder="ชื่อแรก">
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label><i class="fa fa-user-circle-o"></i> นามสกุล</label>
                                                    <input type="text" class="form-control" v-model="rs_getbyShops.shops_lastname" id="shops_lastname" name="shops_lastname" placeholder="นามสกุล">
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label><i class="fa fa-external-link"></i> ที่อยู่ของร้านค้า</label>
                                                    <input type="text" class="form-control" v-model="rs_getbyShops.shops_link" id="shops_link" name="shops_link" placeholder="https://...">
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label><i class="fa fa-photo"></i> ที่อยู่ของโลโก้ร้านค้า</label>
                                                    <input type="url" class="form-control" v-model="rs_getbyShops.shops_logourl" id="shops_logourl" name="shops_logourl" placeholder="https://...">
                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label><i class="fa fa-list"></i> รายละเอียดร้านค้า</label>
                                                    <textarea rows="5" name="shops_desc" class="form-control" v-model="rs_getbyShops.shops_desc" placeholder="รายละเอียดร้านค้า"></textarea>
                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label><i class="fa fa-address-book-o"></i> ที่อยู่</label>
                                                    <textarea rows="5" name="shops_address" class="form-control" v-model="rs_getbyShops.shops_address" placeholder="ที่อยู่"></textarea>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label><i class="fa fa-phone-square"></i> เบอร์โทร</label> 
                                                    <input type="number" 
                                                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "10"
                                                    name="shops_tel" value="" class="form-control" v-model="rs_getbyShops.shops_tel" placeholder="เบอร์โทร">
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label><i class="fa fa-send-o"></i> ไปรษณีย์</label>
                                                    <input type="number" 
                                                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "6"
                                                    name="shops_zipcode" value="" class="form-control" v-model="rs_getbyShops.shops_zipcode" placeholder="ZIP Code">
                                                </div>
                                            </div>
                                            
                                       

                                            <div class="col-lg-12 text-center">
                                                <button class="btn btn-warning" @click="updateShops();"><i class="fa fa-pencil-square-o"></i> อัพเดต</button>
                                                <button class="btn btn-danger" @click="deleteShop();"><i class="fa fa-trash"></i> ลบร้านค้า</button>
                                            </div>
                                         </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>

    <div class="py-5 border-top">
        <div class="row justify-content-center">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 mb-2"><h5 class="text-center">ตั้งค่าการเชื่อมต่อบริการ API</h5></div>
                    <div class="col-lg-6">
                        <div class="text-center"><b >ตั้งค่า API (Request)</b></div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label><i class="fa fa-address-book-o"></i> Shop ID :</label> <input type="text" class="form-control" v-model="rs_getbyShops.shops_id"  disabled> 
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label><i class="fa fa-key"></i> Secret Key :</label>
                                        <span class="pull-right">
                                            <span class="btn btn-default btn-sm" @click="genarateSecretKey();"><i class="fa fa-refresh"></i> สร้างคีย์ใหม่</span>
                                        </span>
                                        <input type="text" style="font-size: 12px;" class="form-control" v-model="rs_getbyShops.callbacks_key" disabled>
                                        <!-- <span id="SecretKey">JTZAE89H4ZJ49SZ65TJ</span> -->
                                    </div>
                                </div>

                                <div class="col-lg-12">
                                    <p>
                                        <a href="https://developers.payremind.com/" target="_blank">คู่มือการใช้ API อ่านได้ที่นี้</a>
                                    </p>
                                </div>
                            </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="text-center"><b >ตั้งค่า API (Response)</b></div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <label><i class="ni ni-compass-04"></i> URL Callback (ใช้สำหรับการรับข้อมูลจากระบบ)</label>
                                    <input type="text" class="form-control" v-model="rs_getbyShops.callbacks_url" name="callbacks_url" id="callbacks_url" placeholder="URL Callback" value="URL Callback">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 text-center">
                        <button type="submit" name="submit" @click="updateServiceApi();" class="btn btn-warning"><i class="fa fa-pencil-square-o"></i> อัพเดต</button>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>

        

</div>
</template>

<script>
import HeaderShop from '@/layout/shop/Header'
import Shops from "@/stores/Shops";
import router from "@/router";
export default {
  name: 'Setting',
  components: {
    HeaderShop
  },
  data(){
      return {
        rs_getbyShops: [],
        linklinenotify: []
      }
  },
  methods: {
    checkUrl: function(url){
            let input_value = url;
            
        //Set input value to lower case so HTTP or HtTp become http
            input_value = input_value.toLowerCase();
        
        //Check if string starts with http:// or https://
        let regExr = /^(?:(http|https|ftp):\/\/)?(?:[\w-]+\.)+[a-z]{2,6}(\/)?/i;
        
        //Test expression
        let result = regExr.test(input_value);
        
        //If http:// or https:// is not present add http:// before user input
        if (!result){
            // let new_value = "http://"+input_value+".com";
            // this.rs_getbyShops.users_id=new_value;
            alert('โปรดกรอกข้อมูลที่อยู่เว็บไซต์ให้ถูกต้อง')
            return false;
        }
        return true;
    },
    genarateSecretKey: async function(){
        if (!localStorage.access_token) router.push("/");
        if (
            this.$route.params.id == undefined
        ) {
            return alert('โปรดกรอกข้อมูลให้ครบถ้วน')
        }

        let optionts = {
            access_token: localStorage.access_token,
            shops_id: this.$route.params.id
        };
        await Shops.dispatch("genarateSecretKey", optionts);
        if (Shops.state.SecretKey.status == 200) {
            this.rs_getbyShops.callbacks_key = Shops.state.SecretKey.callbacks_key
        } else if (Shops.state.SecretKey.status == 400) {
            alert(Shops.state.SecretKey.msg)
        }
    },
    getbyShops: async function() {
      if (!localStorage.access_token) router.push("/");
      let optionts = {
        access_token: localStorage.access_token,
        shops_id: this.$route.params.id
      };
      await Shops.dispatch("getbyShops", optionts);
      if (Shops.state.rs_getbyShops.status == 200) {
        this.rs_getbyShops = Shops.state.rs_getbyShops.data;
      } else if (Shops.state.rs_getbyShops.status == 400) {
        router.push("/logout");
      }
    },
    updateShops: async function() {
        if(!this.checkUrl(this.rs_getbyShops.shops_link)){
            return;
        }
        if(!this.checkUrl(this.rs_getbyShops.shops_logourl)){
            return;
        } 
        if (!localStorage.access_token) router.push("/");
        if (
            this.rs_getbyShops.shops_name == '' || 
            this.rs_getbyShops.shops_cardid == '' || 
            this.rs_getbyShops.shops_firstname == '' || 
            this.rs_getbyShops.shops_lastname == '' || 
            this.rs_getbyShops.shops_link == '' || 
            this.rs_getbyShops.shops_logourl == '' || 
            this.rs_getbyShops.shops_desc == '' || 
            this.rs_getbyShops.shops_tel == '' || 
            this.rs_getbyShops.shops_zipcode == '' || 
            this.rs_getbyShops.shops_address == '' || 

            this.rs_getbyShops.shops_name == undefined || 
            this.rs_getbyShops.shops_cardid == undefined || 
            this.rs_getbyShops.shops_firstname == undefined || 
            this.rs_getbyShops.shops_lastname == undefined || 
            this.rs_getbyShops.shops_link == undefined || 
            this.rs_getbyShops.shops_logourl == undefined || 
            this.rs_getbyShops.shops_desc == undefined || 
            this.rs_getbyShops.shops_tel == undefined || 
            this.rs_getbyShops.shops_zipcode == undefined || 
            this.rs_getbyShops.shops_address == undefined 

                ) {
                return alert('โปรดกรอกข้อมูลให้ครบถ้วน')
            }

        let optionts = {
            access_token: localStorage.access_token,
            shops_id: this.$route.params.id,
            shops_name: this.rs_getbyShops.shops_name,
            shops_cardid: this.rs_getbyShops.shops_cardid,
            shops_firstname: this.rs_getbyShops.shops_firstname,
            shops_lastname: this.rs_getbyShops.shops_lastname,
            shops_link: this.rs_getbyShops.shops_link,
            shops_logourl: this.rs_getbyShops.shops_logourl,
            shops_desc: this.rs_getbyShops.shops_desc,
            shops_tel: this.rs_getbyShops.shops_tel,
            shops_zipcode: this.rs_getbyShops.shops_zipcode,
            shops_address: this.rs_getbyShops.shops_address
        };
        await Shops.dispatch("updateShops", optionts);
        if (Shops.state.rs_updateShops.status == 200) {
            alert("บันทึกข้อมูลสำเร็จ")
            // await this.getUser();
        } else if (Shops.state.rs_updateShops.status == 400) {
            alert(Shops.state.rs_updateShops.msg)
        }
    },
    updateServiceApi: async function() {
        if (!localStorage.access_token) router.push("/");
        if (
            this.rs_getbyShops.callbacks_url == '' ||
            this.rs_getbyShops.callbacks_url == undefined 
        ) {
            return alert('โปรดกรอกข้อมูลให้ครบถ้วน')
        }

        let optionts = {
            access_token: localStorage.access_token,
            callbacks_url: this.rs_getbyShops.callbacks_url,
            shops_id: this.$route.params.id,
        };
        await Shops.dispatch("updateServiceApi", optionts);
        if (Shops.state.ServiceApi.status == 200) {
            alert("บันทึกข้อมูลสำเร็จ")
            // await this.getUser();
        } else if (Shops.state.ServiceApi.status == 400) {
            alert(Shops.state.ServiceApi.msg)
        }
    },
    deleteShop: async function() {
        if (!localStorage.access_token) router.push("/");
        if (!confirm('ยืนยันการลบร้านค้านี้')) {
            return
        }
        let optionts = {
            access_token: localStorage.access_token,
            shops_id: this.$route.params.id,
        };
        await Shops.dispatch("deleteShop", optionts);
        if (Shops.state.rs_delete.status == 200) {
            alert("ลบร้านค้านี้เสร็จสิ้น")
            router.push("/user/mangeshops");
        } else if (Shops.state.rs_delete.status == 400) {
            alert(Shops.state.rs_delete.msg)
        }
    },
    LoadLinklinenotify: async function() {
        if (!localStorage.access_token) router.push("/");
        let optionts = {
            access_token: localStorage.access_token,
            shops_id: this.$route.params.id
        }      
        await Shops.dispatch('getLinkLineNotify',optionts)
        // console.log("SS")
        if(Shops.state.LinkLineNotify.status == 200){
            this.linklinenotify = Shops.state.LinkLineNotify.url;
        }
    },
  },
  async mounted() {
    await this.getbyShops();
    await this.LoadLinklinenotify()
  }
  
}

</script>
